var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7808 7.55762H2.3623V9.02868H21.7808V7.55762Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5191 13.5879H2.10059V15.059H21.5191V13.5879Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8008 20.2464V7.55762H11.3414V20.2464H12.8008Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4289 2.82063L4.7176 2.6964C3.1137 2.68286 1.80258 3.9825 1.78915 5.59924L1.6895 17.5886C1.67606 19.2053 2.96539 20.5269 4.56929 20.5405L19.2806 20.6647C20.8845 20.6783 22.1956 19.3786 22.209 17.7619L22.3087 5.77252C22.3221 4.15578 21.0328 2.83418 19.4289 2.82063Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19.36,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.a32f197ea3936825f37da883b5819fff.svg";
export { ForwardRef as ReactComponent };